$(document).ready(function() {

  const PageInits = {
    /*=== Collection Page ===================================================*/
    collection: function(a){
      var top = 0;
      var main = $(a);
      var randomClass = ( 'eH' + Math.random() ).replace('.','');
      // console.log('A random class: ' + randomClass); // ?
      main.each( function() {

        var distanceFromTop = $(this).offset().top;
        // console.log('This is ' + distanceFromTop + ' from the top.');

        if ( distanceFromTop > top ) {
          $('.' + randomClass).removeClass(randomClass);
          top = distanceFromTop;
          // console.log('"top" is ' + top + 'px away');
        }

        $(this).addClass(randomClass);

        $(this).css('min-height','auto');

        var newHeight = (Math.max.apply(null, $('.' + randomClass).map( function() {
          return $(this).outerHeight();
        }).get()));

        $('.' + randomClass).css('min-height',newHeight);

      }).removeClass(randomClass);

    }
  }


  const $navbar = $('#site-control');
  $('a[href*="#"]:not([href="#"]').on('click', function(e) {
    e.preventDefault();

    const scrollTop =
          $($(this).attr('href')).position().top -
          $navbar.outerHeight();

    $('html, body').animate({ scrollTop });
  });

  //Product Tab Accordian

  function productTabAccordion() {
    $(".accordian").each(function() {
      $(this).find(".accordian__title").click(function(e) {
        e.preventDefault();
        var $p = $(this).parents(".accordian").first();
        var hp = $p.outerHeight();
        var $expand = $(this).siblings(".accordian__content").first();
        var $h = $expand.find(".expand-area-interior").first();
        if ($expand.hasClass("active")) {
          // closing
          if ($(this).attr("data-expand")) {
            $(this).text($(this).attr("data-expand"));
          }
          $(this).removeClass("active");
          var h = $expand.outerHeight();
          $expand.css("height", h);
          if ($p.hasClass("expand-auto-close")) {
            $p.css("height", hp);
          }
          setTimeout(function() {
            $expand.removeClass("active").css("height", "");
            $p.css("height", "");
          }, 5)
        } else {
          var h = $h.outerHeight();
          if ($p.hasClass("expand-auto-close")) {
            $p.find(".accordian__title.active").trigger("click");
          }
          if ($p.hasClass("expand-auto-close-tooltip")) {
            $("body").find(".expand-auto-close-tooltip .accordian__title.active").trigger("click");
          }
          if ($p.hasClass("auto-close-sibling")) {
            $p.siblings(".auto-close-sibling").find(".accordian__title.active").trigger("click");
          }
          if ($(this).attr("data-collapse")) {
            $(this).text($(this).attr("data-collapse"));
          }
          $(this).addClass("active");
          $expand.addClass("active").addClass("transitioning").css("height", h);
          setTimeout(function() {
            $expand.css("height", "auto").removeClass("transitioning");
            $p.css("height", "auto");
          }, 250)
        }
      })
    });
  }
  productTabAccordion();

  // Product color swatches

  window.reloadProduct = (reload, refresh) => {
    loadProduct(reload, refresh);
  }

  

  function loadProduct(reload, refresh) {
    // console.log('loadProduct');
    let $colorSwatch = $('.product-nav__new-select-color .tf-product-dropdown__option a');
    let $container = $colorSwatch.parents('.section-product-template');
    let $colorOption = $('.product-nav__new-select-color');
    // console.log('$container',$container);

    // Load html for each color page
    $colorSwatch.each(function(e) {
      let $this = $(this);
      let prodductURL = $this.attr('href');

      $.ajax({
        type: 'GET',
        dataType: 'html',
        url: prodductURL,
        success: function (data) {
          // console.log('data',data);
          let productWrapper = $(data).find('.section-product-template').prop('outerHTML');
          // console.log('productWrapper',productWrapper);
          $this.attr('data-page-html', productWrapper);
          // console.log('$this',$this);
        }
      });
    });

    function addDataAttribute(el, name, data) {
      el.data(name, data);
    }

    $colorSwatch.on('click', function (e) {
      e.preventDefault();
      console.log("Document state", document.readyState);
      //$colorOption.addClass('locked');

      let newHTML = $(this).data('page-html');
      let $newElement = $.parseHTML(newHTML);
      let url = $(this).attr('href');
      let title = $(this).data('title');

      console.log('$newElement',$newElement, $newElement);

      $($newElement).attr("style",`min-height:${ $container.height() }px;`);

      if($newElement.length > 0) {
        $container.replaceWith($newElement);
        var obj = { Title: title, Url: url };
        window.history.replaceState(obj, obj.Title, obj.Url);
        window.reloadProduct(true, false);
      } else {
        window.reloadProduct(true, true);
      }
    });

    if (reload) {
      console.log("RELOAD PRODUCT FUNCTIONS");
      // Reload product functions
      theme.Sections.register('product-template', theme.ProductTemplateSection, {
        deferredLoadViewportExcess: 200
      });

      productTabAccordion();
    }

    if (refresh) {
      // Refresh page for Klavyo BIS form
      $('.product-area .theme-images').hide();
      location.reload(false);
    }
  }
  loadProduct();
  /*** Custom color select ***/
  // (function() {
  //   var $color= $('.product-nav__select-color');
  //   var $colorOption = $('.product-nav__new-select-color .tf-product-dropdown__option.enabled');
  //   var $colorSelect = $('.product-nav__new-select-color');
  //   $colorSelect.click(function() {
  //     $(this).toggleClass('open');
  //     // console.log("------------");
  //     // console.log("product nav bucket? " + $(this).parents(".product-nav-bucket").length);
  //     if ($(this).parents(".product-nav-bucket").length) {
  //       var $p = $(this).parents(".product-nav-bucket").first();
  //       // console.log("siblings buckets: " + $p.siblings(".product-nav-bucket").length);
  //       // console.log("sibling open: " + $p.siblings(".product-nav-bucket").find(".tf-product-dropdown.open").length);
  //       if ($p.siblings(".product-nav-bucket").find(".tf-product-dropdown.open").length) {
  //         // $p.siblings(".product-nav-bucket").find(".tf-product-dropdown__option-title").trigger("click");
  //         $p.siblings(".product-nav-bucket").find(".tf-product-dropdown.open").removeClass("open");
  //         // trigger creates a loop of these events, so just removing class instead;
  //       }
  //     }
  //   });
  //   $colorOption.on('click', function (e) {
  //     var optionSelectedUrl = $(this).data().url;
  //     $.getJSON(optionSelectedUrl + '.js', function(product) {
  //       window.location.replace(product.url);
  //     });
  //   });
  // })();

  /*** Custom size select ***/

  /*** disable by default, enable after picking a size ***/
  var $size = $('.product-nav__select-size');
  var $addToBagBtn = $('.add-to-bag');
  // var $addToBagForm = $('.add-to-bag');
  $size.on('change', function (e) {
    var selectedVariantId = $("option:selected", this).val();
    var selectedVariantPrice = $("option:selected", this).attr('data-productprice');
    _updateProductPrice(selectedVariantPrice);
    _updateAddToBagBtn(selectedVariantId, selectedVariantPrice);
  });
  var $sizeSelect = $('.product-nav__new-select-size');
  // var $sizeValue = $('.product-nav__new-select-size .tf-product-dropdown__option-title');
  var $sizeOption = $('.product-nav__new-select-size .tf-product-dropdown__option');
  var $lastSizeOption = null;

  $(document).on("click",".product-nav__new-select-size",function() {
    //$sizeSelect.click(function() {
    //$sizeSelect.on('click', function (e) {

    console.log("Select Size");

    $(this).toggleClass('open');
    // auto close others for PDP
    // console.log("product nav bucket? " + $(this).parents(".product-nav-bucket").length);
    if ($(this).parents(".product-nav-bucket").length) {
      var $p = $(this).parents(".product-nav-bucket").first();
      // console.log("siblings buckets: " + $p.siblings(".product-nav-bucket").length);
      // console.log("sibling open: " + $p.siblings(".product-nav-bucket").find(".tf-product-dropdown.open").length);
      if ($p.siblings(".product-nav-bucket").find(".tf-product-dropdown.open").length) {
        // $p.siblings(".product-nav-bucket").find(".tf-product-dropdown__option-title").trigger("click");
        $p.siblings(".product-nav-bucket").find(".tf-product-dropdown.open").removeClass("open");
      }
    }
  });

  $(document).on("click",".product-nav__new-select-size .tf-product-dropdown__option",function() {
    //$sizeOption.on('click', function (e) {
    console.log('slick size');
    var $el = $(this);
    var $form = $el.parents(".product-nav--actions").first().find("form"); // Sticky form
    var $sliderForm = $el.parents('form'); // Slider form
    var $oosform = $('.product-nav-waitlist');
    var data = $el.data();
    //console.log(data);
    //$('.select_size__button').hide();
    if ($lastSizeOption) {
      $lastSizeOption.removeClass('selected');
    }
    $el.addClass('selected');
    $lastSizeOption = $el;
    var selectedVariantId = data.variantId;
    var selectedVariantPrice = data.variantPrice;
    var selectedVariantStock = data.variantStock;
    var $sizeValue = $('.slick-active .product-nav__new-select-size .tf-product-dropdown__option-title');

    console.log('selectedVariantId: '+selectedVariantId);
    if (!$sizeValue.length) {
      $sizeValue = $(this).parents('.tf-product-dropdown').first().find('.tf-product-dropdown__option-title');
      var $sizeId = $(this).parents("form").first().find("[name=id]");
      $addToBagBtn = $(this).parents("form").first().find(".add-to-bag");

      if (!$sizeId.length || !$addToBagBtn.length) {
        $sizeId = $form.find("[name=id]");
        $addToBagBtn = $form.find(".add-to-bag");
      }
      $sizeId.attr("value", selectedVariantId);
      if($addToBagBtn.prop('disabled')) {
        $addToBagBtn.prop('disabled', false);
        $addToBagBtn.val("Add To Bag");
      }
    } else {
      _updateProductPrice(selectedVariantPrice);
      _updateAddToBagBtn(selectedVariantId, selectedVariantPrice);
    }
    $sizeValue.text('Size ' + $el.text());
    if($el.hasClass('outofstock') || selectedVariantStock == 0) {

      if($el.hasClass('enabled')) {

        $oosform.hide();
        $oosform.find('input').prop('disabled', true);
        $form.find('.notify-stock').hide();
        $sliderForm.find('.notify-stock').hide();
        $form.find('.add-to-bag').show();
        $sliderForm.find('.add-to-bag').show();
        $sliderForm.find('.add-to-bag').val('Add To Bag');

      } else{

        $oosform.show();
        $oosform.find('[name="out_of_stock_variant"]').val(selectedVariantId);
        $oosform.find('input').prop('disabled', false);
        $form.find('.notify-stock').show();
        $sliderForm.find('.notify-stock').show();
        $form.find('#AddToCart-new-product-template').hide();
        $sliderForm.find('#AddToCart-new-product-template').hide();
        $form.find('.add-to-bag').hide();
        //$sliderForm.find('.add-to-bag').hide();
        $sliderForm.find('.add-to-bag').val('Out Of Stock');
        $sliderForm.find('.add-to-bag').prop('disabled', true);

        // If we're using the form on the homepage slider update the notify me button URL
        if ($sliderForm.length) {
          var productURL = $sliderForm.find('[data-producturl]').attr('data-producturl') + '?variant=' + selectedVariantId + '&open_bis=true';
          $sliderForm.find('.notify-stock').attr('href', productURL);
          // console.log('productURL',productURL);
        }

      }

    } else {
      $oosform.hide();
      $oosform.find('input').prop('disabled', true);
      $form.find('.notify-stock').hide();
      $sliderForm.find('.notify-stock').hide();
      $form.find('.add-to-bag').show();
      $sliderForm.find('.add-to-bag').show();
      $sliderForm.find('.add-to-bag').val('Add To Bag');
    }

    // If we're using the form on PDP update the URL
    // console.log('slate.utils.getParameterByName("open_bis")',slate.utils.getParameterByName('open_bis'));
    if ($form.length && slate.utils.getParameterByName('open_bis') !== 'true') {
      var newurl =
          window.location.protocol +
          '//' +
          window.location.host +
          window.location.pathname +
          '?variant=' +
          selectedVariantId;
      window.history.replaceState({ path: newurl }, '', newurl);
    }
  });
  function _updateAddToBagBtn(productId, selectedVariantPrice) {
    // console.log("_updateAddToBagBtn: " + productId);
    if (!productId) {
      //console.log("no product ID");
    }
    var $addToBagInput = $('.slick-active #product-select').first();
    $addToBagInput.attr('data-productid', productId);
    $addToBagInput.attr('data-productprice', selectedVariantPrice);
    // console.log($addToBagInput, productId);
    $addToBagInput.val(productId);
    /*** disable by default, enable after picking a size ***/
    if($addToBagBtn.prop('disabled')) {
      $addToBagBtn.prop('disabled', false);
      $addToBagBtn.val("Add To Bag");
    }
  };
  function _updateProductPrice(price) {
    var $currentPriceDesktopSelector = $('#product-nav--title span').text().split('-')[0];
    var $currentPriceMobileSelector = $('#product-accordeon--mobile--product-price');
    var price = theme.Currency.formatMoney(
      price,
      theme.moneyFormat
    );
    $('#product-nav--title span').text(`${$currentPriceDesktopSelector} - ${price}`);
    $currentPriceMobileSelector.text(price);
  }
  $addToBagBtn.prop('disabled', true);


  //=== Sticky Newsletter ===//
  if($(".page-sections").length > 0){
    $(window).scroll(function(){
      var newsLetterDiv = $(".page-sections")[0].offsetTop;
      if ($(this).scrollTop() > newsLetterDiv) {
        $('.newsletter-hero__content').removeClass('sticky-newsletter');
      } else {
        $('.newsletter-hero__content').addClass('sticky-newsletter');
      }
    });
  }

  console.log("Custom.js")

  $(document).on("click", ".open-sort-by", function(e){

    $(this).parent('.cc-product-filter_button').find(`button[type="button"]:not(.open-sort-by)`).each(function(e){
      var triggerClass = "."+$(this).data("trigger");
      var triggerRemoveClass = $(this).data("triggered-class");
      if(triggerRemoveClass == undefined){
        if($(triggerClass).is(":visible")){
          $(this).removeClass("active");
          $(triggerClass).hide()
        }
      }else{
        $(triggerClass).removeClass(triggerRemoveClass);
        $(this).removeClass("active");
      }
    });

    $(this).toggleClass("active");
    if($(this).hasClass("active")){
      $(".cc-product-filter-sort-by").show()
    }
    else{
      $(".cc-product-filter-sort-by").hide()
    }

  });

  $(document).on("click", ".color-swatch__option-more", function(){
    let initalLeft = $(this).prev(".color-swatch__option-inner-container").scrollLeft();
    let slideWidth =  $(".color-swatch__option").width();
    $(this).prev(".color-swatch__option-inner-container").scrollLeft(initalLeft + slideWidth);
  });

  //Product Select Size
  $(document).on("click",".select_size",function(e) {
    e.preventDefault();
  });

  //super_here_1  super_here_1
  $(document).on("click",".super_here_1",function(e) {
    e.preventDefault();
    $('#button_section_recycle_block').click();
  });
  $(document).on("click",".super_here_2",function(e) {
    e.preventDefault();
    $('#button_section_super_block').click();
  });

  $(document).on("click",".super_here_3",function(e) {
    e.preventDefault();
    $('#button_section_pledge_block').click();
  });
  $(document).on("click",".super_here_4",function(e) {
    e.preventDefault();
    $('#button_section_super_block').click();
  });

  $(document).on("click",".super_here_5",function(e) {
    e.preventDefault();
    $('#button_section_pledge_block').click();
  });
  $(document).on("click",".super_here_6",function(e) {
    e.preventDefault();
    $('#button_section_recycle_block').click();
  });  

  //data-cc-animate-click
  $(document).on("click","#page-supercircle-by-thousand-fell [data-cc-animate-click]",function(e) {
    e.preventDefault();
    //$('#numberedcolumns').click();

    var target = $('#numberedcolumns');
    //if(target.length){
    //$('.section-hnewsletter').removeClass('opened');
    //target.addClass('opened');
    var scrollTo = target.offset().top - 73;
    $('body, html').animate({scrollTop: scrollTo+'px'}, 800);

  });

  window.onclick = function(event) {
    if (event.target == document.querySelector(".modal.collection_modal")) {
      document.querySelector(".modal.collection_modal").style.display = "none";
      $("body").removeClass("collection_modal_overlay");
    }
  }


  var swiperOptions = {
    loop: true,
    autoplay: {
      delay: 1,
      disableOnInteraction: false
    },
    slidesPerView: 'auto',
    speed: 10000,
    grabCursor: false,
    mousewheelControl: false,
    keyboardControl: false
  };

  var swiper = new Swiper(".bar.swiper-container", swiperOptions);

  $('.button-super').click(function(e){
    var target = $($(this).attr('href')),
        href = $(this).attr('href');
    if(href.includes("#")){
      e.preventDefault();
      $('.section-hnewsletter').removeClass('opened');
      target.addClass('opened');
      var scrollTo = target.offset().top - 73;
      $('body, html').animate({scrollTop: scrollTo+'px'}, 800);
    }
  });

  $(".section_close").click(function(e){
    $('.section-hnewsletter').removeClass('opened');
  })

  var quoteOptions = {
    loop: true,
    autoplay: false,
    slidesPerView: 3,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    scrollbar: false,
    breakpoints: {
      // when window width is >= 320px
      768: {
        slidesPerView: 1,
        spaceBetween: 40
      },
      // when window width is >= 640px
      1200: {
        slidesPerView: 2,
        spaceBetween: 30
      }
    }
  };

  var swiper = new Swiper(".section-testimonials .swiper-container", quoteOptions);



  //$('.product-detail__form .product-detail__form__options')

  $('.footer-button-xs .button.select_size').click(function(e){
    e.preventDefault();
    var target = $('.product-detail__form .product-detail__form__options');
    //if(target.length){
    var scrollTo = target.offset().top - 73;
    $('body, html').animate({scrollTop: scrollTo+'px'}, 800);
    // }
  });
  
  
  
  $(window).scroll(function() {
    var target = $('.view-cart-wrap');
    if (!target.length > 0) return;
    var scrollTo = target.offset().top - 73;
    var height = $(window).scrollTop();
    if (scrollTo < height) {
      $(".checkout--wrap").addClass("show_checkout");
    } else {
      $(".checkout--wrap").removeClass("show_checkout");
    }
  });


  PageInits.collection('.product-block .product-block__info > a.caption ');
  PageInits.collection('.product-block .product-block__info');

  $( window ).scroll(function() {
    PageInits.collection('.product-block .product-block__info > a.caption ');
    PageInits.collection('.product-block .product-block__info');
  });
  $( window ).resize(function() {
    PageInits.collection('.product-block .product-block__info > a.caption ');
    PageInits.collection('.product-block .product-block__info');
  });


  $(document).on("click", ".view-cart--btn:not(.checkout)", function(){
    window.location.href = "/cart";
  });

  $(document).on("click", ".clear.clear-tags", function(){
    let id = $(this).parent().find(".cc-tabs__accordion__header").attr("aria-controls");
    $(`#${id}`).find("li.active[data-tag]").find("button").click();
  });
  if($(document).find(".product-block").length){
    $(".product-block").each(function(){
//       $(this).find("form");
//       console.log($(this).find("form"));
      theme.applyAjaxToProductForm($(this).find("form"));
    })
  }
});


